import generateJavaRequest from './services/jrequest';

const jRegionRequest = generateJavaRequest('basics');

/**
 * 获取省
 * @param {*} conditions
 */
export function getProvince(conditions) {
  return jRegionRequest('province', conditions);
}

/**
 * 获取市区
 * @param {*} conditions
 */
export function getCity(conditions) {
  return jRegionRequest('city', conditions);
}

/**
 * 获取微信分享配置
 * @param {*} condiotions
 */
export function weixinconfig(condiotions) {
  return jRegionRequest('weixin/share', condiotions);
}
